/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid } from "@mui/material";
import { FC, Fragment, useContext } from "react";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import InputTextfield from "../../../../../shared/components/textField";
import { FormContainer } from "../../../../../shared/components/formContainer";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useMutation from "../../../../../shared/components/hooks/useMutation";
// import { customizeValidationSchema } from "../variables/customSchema";
import { getValidationSchema } from "../../../../../shared/validations/schema";

const ResetUserPassword: FC = () => {
  const { id } = useParams();
  const { payload, setPayload } = useContext(SidebarContext);

  const { loading: apiLoading, modifyData } = useMutation(
    "/user-management/users"
  );

  const textFields = [
    {
      id: "newPassword",
      name: "newPassword",
      label: "New Password",
      placeholder: "Enter your new password",
      type: "text",
    },
    {
      id: "confirmPassword",
      name: "confirmPassword",
      label: "Confirm Password",
      placeholder: "Confirm your new password",
      type: "text",
    },
  ];

  const initialValues = {
    newPassword: "",
    confirmPassword: "",

  }

  const resetUserPasswordForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: getValidationSchema(["newPassword","confirmPassword"]),
    onSubmit: async (formData: any) => {
      const response = await modifyData(`/reset-password`, "post", {
        token: id,
        password: formData.newPassword,
      });
    },
  });

  const titleBar = {
    headerTitle: "Reset User Password",
    title: "Reset User Password",
    buttonTitle: "Save",
    onClick: () => resetUserPasswordForm.handleSubmit(),
    dirty: resetUserPasswordForm.dirty,
    buttonLoading: apiLoading,
  };

  return (
    <>
      <FormContainer titleBar={titleBar}>
        <Box className="border-custom">
          <Grid container alignItems="stretch" columnSpacing={4} rowSpacing={2}>
            {textFields.map((field: any, index: number) => (
              <Fragment key={field.id}>
                {(field?.formField === undefined ||
                  field.formField === true) && (
                    <Grid item md={6} sm={6} xs={12}>
                      <InputTextfield
                        form={resetUserPasswordForm}
                        fieldProps={field}
                        key={index}
                      />
                    </Grid>
                  )}
              </Fragment>
            ))}
          </Grid>
        </Box>
      </FormContainer>
    </>
  );
};
export default ResetUserPassword;
